class CourseListState {
    public types: string[] = []
    public defaultValue: string = '-1'
}

export default CourseListState


// WEBPACK FOOTER //
// ./src/components/schedule/course-list/CourseListState.ts